import { useCountUp } from "react-countup";
import { useRef, useEffect } from "react";
import React from 'react';
import ReactDOM from 'react-dom/client';


function CounterApp({ start, end, duration, prefix, suffix, decimals }) {
    const countUpRef = useRef(null);
    useCountUp({
        ref: countUpRef,
        start: start || 0,
        end: end,
        duration: duration || 2,
        prefix: prefix || "",
        suffix: suffix || "",
        decimals: decimals || 0,
        enableScrollSpy: true,
    });
    return <span ref={countUpRef} />;
}


// Highlights
ReactDOM.createRoot(document.getElementById('counter01')).render(<CounterApp end={40} suffix=" million" />);
ReactDOM.createRoot(document.getElementById('counter02')).render(<CounterApp end={300} prefix="Over " />);
ReactDOM.createRoot(document.getElementById('counter03')).render(<CounterApp end={1066182} />);

// Let's Pray
ReactDOM.createRoot(document.getElementById('counter04')).render(<CounterApp end={2200} suffix={"+"} />);

// Events
ReactDOM.createRoot(document.getElementById('counter05')).render(<CounterApp end={34} />);
ReactDOM.createRoot(document.getElementById('counter06')).render(<CounterApp end={20} suffix="k" />);
ReactDOM.createRoot(document.getElementById('counter07')).render(<CounterApp end={68} suffix="k" />);

// Digital Platforms
ReactDOM.createRoot(document.getElementById('counter08')).render(<CounterApp end={100000} />);

// Social Media
ReactDOM.createRoot(document.getElementById('counter09')).render(<CounterApp end={339} suffix={'%'} />);
ReactDOM.createRoot(document.getElementById('counter10')).render(<CounterApp end={6929165} />);
ReactDOM.createRoot(document.getElementById('counter11')).render(<CounterApp end={212} suffix={'%'} />);
ReactDOM.createRoot(document.getElementById('counter12')).render(<CounterApp end={1029874} />);

// Ambassadors
ReactDOM.createRoot(document.getElementById('counter13')).render(<CounterApp end={49} />);
ReactDOM.createRoot(document.getElementById('counter14')).render(<CounterApp end={39} />);

// Income
ReactDOM.createRoot( document.getElementById('counter15')).render(<CounterApp end={8} duration={3} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter15b')).render(<CounterApp end={8} duration={3} suffix={"%"} />);
ReactDOM.createRoot( document.getElementById('counter16')).render(<CounterApp end={18} duration={3}  suffix={"%"}/>);
ReactDOM.createRoot(document.getElementById('counter16b')).render(<CounterApp end={18} duration={3} suffix={"%"}/>);
ReactDOM.createRoot( document.getElementById('counter17')).render(<CounterApp end={74} duration={3} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter17b')).render(<CounterApp end={74} duration={3} suffix={"%"} />);

// Expenses
ReactDOM.createRoot(document.getElementById('counter18')).render(<CounterApp end={80.4} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter18b')).render(<CounterApp end={80.4} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter19')).render(<CounterApp end={13.7} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter19b')).render(<CounterApp end={13.7} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter20')).render(<CounterApp end={5.9} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('counter20b')).render(<CounterApp end={5.9} duration={3} decimals={1} suffix={"%"} />);
// ReactDOM.createRoot(document.getElementById('counter21')).render(<CounterApp end={88} duration={3} suffix={"%"} />);
// ReactDOM.createRoot(document.getElementById('counter21b')).render(<CounterApp end={88} duration={3} suffix={"%"} />);

